import { CapoPlugin } from "/tmp/build_3dff4878/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];